import type { ServiceWorkQueue } from "./types";

function isWarrantyQueue(queue: ServiceWorkQueue | null | undefined): boolean {
  if (!queue) return false;
  const slug = queue.slug.trim().toLowerCase();
  return slug === "warranty" || slug.includes("warranty");
}

/** Placeholder for the operational scope description field. */
export function serviceRequestDescriptionPlaceholder(queue: ServiceWorkQueue | null): string {
  if (isWarrantyQueue(queue)) {
    return "Describe the warranty issue, site access, and what the crew should verify on arrival…";
  }
  return "Describe the operational scope — what work is needed on site (not a price quote)…";
}

/** Helper copy under the description field. */
export function serviceRequestIntakeHelpText(queue: ServiceWorkQueue | null): string {
  if (isWarrantyQueue(queue)) {
    return "Intake is for dispatch scope only. Warranty coverage and any customer charge are decided during review — not calculated here.";
  }
  return "Intake captures where and what to fix. Paid-job pricing stays on the Opportunity or dispatcher quote — this form is not a pricing calculator.";
}

export function serviceRequestPhotosHelpText(queue: ServiceWorkQueue | null): string | null {
  if (!queue?.photos_required) return null;
  return "This queue requires at least one site photo before submit.";
}
